import DealXgFetcher from './DealXgFetcher.js';
import getPath from '../../fetchers/utils/getPath.js';
class DealerDealService {
  constructor(_ref) {
    let {
      environment
    } = _ref;
    this.validDeals = [];
    this.lastFetched = null;
    this.fetcher = DealXgFetcher(getPath(environment, {
      prod: 'www.kbb.com',
      staging: 'staging.kbb.com'
    }));
    this.updateDealNotification = this.updateDealNotification.bind(this);
  }
  shouldFetchDeals(walletId) {
    // initial fetch
    if (!this.lastFetched && walletId != null) {
      return true;
    }
    const timeSinceLastFetched = Date.now() - this.lastFetched;
    if (walletId != null && timeSinceLastFetched >= 10000) {
      return true;
    }
    return false;
  }
  validateDeals() {
    let dealDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return dealDetails.reduce((acc, deal) => {
      if (deal.error || typeof deal === 'string') {
        acc.invalidDeals.push(deal);
      } else {
        acc.validDeals.push(deal);
      }
      return acc;
    }, {
      invalidDeals: [],
      validDeals: []
    });
  }
  async getDealDetails(walletId) {
    if (this.shouldFetchDeals(walletId)) {
      const dealDetails = await this.fetcher.fetch(walletId);
      this.lastFetched = Date.now();

      // NOTE: If no dealDetails are found for the wallet id the response will look like:
      // "The walletId \"abc123\" does not exist in the DB"
      if (!dealDetails || dealDetails?.error || typeof dealDetails === 'string') {
        return this.validDeals;
      }
      const {
        validDeals,
        invalidDeals
      } = this.validateDeals(dealDetails);
      if (invalidDeals.length > 0) {
        // eslint-disable-next-line no-console
        console.log('[Deal Xg Service] - ', invalidDeals);
      }
      this.validDeals = validDeals;
    }
    return this.validDeals;
  }
  resetDealNotifications(_ref2) {
    let {
      dealIds = []
    } = _ref2;
    dealIds?.forEach(id => this.fetcher.resetDealNotifications(id));
  }
  updateDealNotification(_ref3) {
    let {
      dealId,
      body
    } = _ref3;
    this.fetcher.resetDealNotifications(dealId, body);
  }
}
export { DealerDealService as default };
